/* eslint-disable no-unused-vars */
import { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectSortedCreativeList,
  select_creatives_list,
  select_not_deleted_creatives_list,
  getActiveCreativesList,
} from 'store/selectors';
import { trackingActions } from 'store/actions';
import { isEqual } from 'lodash-es';
import { usePrevious, checkTrackingLinks, sortCreativeItems } from 'utils';
import { useSignal, useComputed } from '@preact/signals-react';
import { creativesActions } from 'store/campaign/creatives';

export const useFacade = () => {
  const dispatch = useDispatch();
  const creativesList = useSelector(select_not_deleted_creatives_list);
  const creativeList$ = useSignal(creativesList);

  const activeCreativesList = useSelector(getActiveCreativesList);
  const creativesTracking = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.creativesTracking,
  );

  // useEffect(() => {
  //   const countOfActive = creativesList.filter(({ status }) => status === 0).length;
  //   if (countOfActive < 4) {
  //     creativeList$.value = sortCreativeItems(creativesList);
  //   } else {
  //     creativeList$.value = creativesList;
  //   }
  // }, [creativesList]);

  const previousCreativesList = usePrevious(creativesList);

  useEffect(() => {
    if (!isEqual(previousCreativesList, creativesList)) {
      creativeList$.value = creativesList;
    }
  }, [creativesList]);

  useEffect(() => {
    if (
      !checkTrackingLinks(creativesTracking, activeCreativesList) &&
      creativesTracking &&
      activeCreativesList.length
    ) {
      dispatch(trackingActions.changeIsCustomTracking(true));
    }
  }, [activeCreativesList, creativesTracking]);

  const selectedCreativeItem = useSelector((state) => state.creatives.selectedCreative);
  const selectedCreativeItem$ = useSignal(selectedCreativeItem);
  const previousSelectedCreativeItem = usePrevious(selectedCreativeItem);

  useEffect(() => {
    if (!isEqual(previousSelectedCreativeItem, selectedCreativeItem)) {
      selectedCreativeItem$.value = selectedCreativeItem;
    }
  }, [selectedCreativeItem]);

  const showLoader$ = useComputed(() => {
    if (creativeList$.value.length && Object.entries(selectedCreativeItem$.value ?? {}).length) {
      return false;
    } else {
      return true;
    }
  });

  return {
    creativeList$,
    selectedCreativeItem$,
    showLoader$,
  };
};
